import { render, staticRenderFns } from "./ColorTranslation.vue?vue&type=template&id=27f4c94b&scoped=true"
import script from "./ColorTranslation.vue?vue&type=script&lang=js"
export * from "./ColorTranslation.vue?vue&type=script&lang=js"
import style0 from "./ColorTranslation.vue?vue&type=style&index=0&id=27f4c94b&prod&scoped=true&lang=css"
import style1 from "./ColorTranslation.vue?vue&type=style&index=1&id=27f4c94b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4c94b",
  null
  
)

export default component.exports